import type { TouchEvent, MouseEvent } from "react";

/**
 * Calculates the position of the mouse/touch as a
 * percentage relative to its container.
 */
export function getPointerDistance(
  target: HTMLElement,
  event: TouchEvent<Element> | MouseEvent<Element>,
) {
  const { width, height, top, left } = target.getBoundingClientRect();

  let evtPageY: number = 0;
  let evtPageX: number = 0;

  if ("changedTouches" in event) {
    evtPageX = event.changedTouches[0].pageX;
    evtPageY = event.changedTouches[0].pageY;
  } else if ("pageX" in event && "pageY" in event) {
    evtPageY = event.pageY;
    evtPageX = event.pageX;
  }

  return {
    x: Math.max(0, Math.min(1, (evtPageX - left) / width)),
    y: Math.max(0, Math.min(1, (top - evtPageY + height) / height)),
  };
}
